import { Injectable } from '@angular/core';
import { Resolve, Router } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { catchError, mergeMap, switchMap, take } from 'rxjs/operators';
import { ApplicationPermissionsApiService } from '../../services/api';
import { CurrentUserService } from '../../services/current-user.service';
import { GlobalNavigationService } from '../../services/global-navigation.service';
import { noDefaultErrorHandler } from '../../services/interceptors';
import { PermissionContext, Permissions } from '../../types/permissions';

@Injectable({
  providedIn: 'root',
})
export class HomePermissionsResolverService implements Resolve<Permissions> {
  constructor(
    private appPermService: ApplicationPermissionsApiService,
    private router: Router,
    private currentUserService: CurrentUserService,
    private globalNavigationService: GlobalNavigationService,
  ) {}

  resolve(): Observable<Permissions> {
    // We need user to call the permissions below.
    return this.currentUserService.aptitudeUser$.pipe(
      switchMap((user) =>
        this.appPermService.getPermissions(user.userId, [
          { context: PermissionContext.APTITUDE },
          { context: PermissionContext.CROSS_REFERENCE },
          { context: PermissionContext.IMPORT },
        ]),
      ),
      take(1),
      noDefaultErrorHandler(),
      catchError((err) => {
        this.globalNavigationService.goHome();
        return throwError(err);
      }),
      mergeMap((rfpPerms) => {
        if (rfpPerms) {
          return of(rfpPerms);
        } else {
          // id not found or permission denied
          this.globalNavigationService.goHome();
          return throwError('Empty object from rfpApi');
        }
      }),
    );
  }
}
